import { ResponsiveBar } from '@nivo/bar'

import { Bar } from 'components/Tooltip'

import { settings } from 'styles'

const BarChart = props => (
  <div className='full'>
    <ResponsiveBar {...settings} {...props} tooltip={Bar} maxValue={props.max} />
  </div>
)

export default BarChart